export default "__VITE_ASSET__DWZ_aqku__"